export const LoginProviderTypes = {
  DeltaX: 1,
  Google: 2,
  Embed: 4
}